export default "__VITE_ASSET__Dwe9rUTm__"